import { styled } from '@mui/material';

export const SimpleDashboard = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Bottom = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '72px',
  width: '100%',
  maxWidth: '1316px',
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    gap: '44px',
    maxWidth: '880px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '40px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    left: '-16px',
    width: 'calc(100% + 32px)',
    gap: '32px',
  },
}));

export const Img = styled('img')(() => ({
  width: '100%',
}));
